import {
  createStore,
  applyMiddleware,
  compose
} from 'redux'
import reducer from './reducers'
import rootEpic from './epics'
import {
  createEpicMiddleware
  // createStateStreamEnhancer
} from 'redux-most'

// import R from 'ramda'

export const defaultPageState = {
  navigation: {
    perPage: 20,
    pageNum: 1,
    ids: null
  },
  listing: {
    request: {
      isLoading: false,
      progress: 0,
      error: null
    },
    response: {
      total: 0,
      pageNum: 1,
      perPage: 20,
      results: []
    }
  },
  autocomplete: {
    selections: [],
    term: null,
    request: {
      isLoading: false,
      progress: 0,
      error: null
    },
    response: {
      total: 0,
      pageNum: 1,
      perPage: 20,
      results: []
    }
  }
}

export const defaultInstitutionPageState = {
  request: {
    isLoading: false,
    progress: 0,
    error: null
  },
  institution: {},
  activationCodes: defaultPageState
}

const defaultAppState = {
  authStatus: {
    user: null, // {_id: null, profile: { }},
    request: {
      xhr: null,
      isLoading: false,
      progress: 0,
      error: null
    }
  },
  pageName: null,
  type: null,
  pages: {
  }
}

const epicMiddleware = createEpicMiddleware(rootEpic)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  reducer,
  defaultAppState,
  composeEnhancers(
    // createStateStreamEnhancer(epicMiddleware),
    applyMiddleware(epicMiddleware)
  )
)
const replaceRootEpic = () => {
  const nextRootEpic = require('./epics').default
  epicMiddleware.replaceEpic(nextRootEpic)
}

if (module.hot) {
  module.hot.accept('./epics', replaceRootEpic)
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers/index')
    store.replaceReducer(nextRootReducer)
  })
}

export default store



// WEBPACK FOOTER //
// ./webAdmin/store.js